import React, { Component } from 'react'
import { imageProps, getIcon, getItemsContainerClass, getItemContainerClass } from './util'
import { Image } from '../../image/image'
import { ExpandableContainer } from '../menu/expandable.container'
import { AccordionContainer } from '../menu/accordion.container'

const addUtmSourceItem = (link, analyticsCategory, analyticsItem) =>
  `${link}?view_source=nav_bar&view_medium=nav_bar_${analyticsCategory.replace(
    /[^\w\s!?]/g,
    ''
  )}_${analyticsItem.replace(/[^\w\s!?]/g, '')}`

const addUtmSourceCategory = (link, analyticsCategory) =>
  `${link}?view_source=nav_bar&view_medium=nav_bar_${analyticsCategory.replace(/[^\w\s!?]/g, '')}`

export class CategoriesContainer extends Component {
  constructor() {
    super()
  }

  renderItems(category, categoryIndex) {
    const itemContainerClass = getItemContainerClass(category.items.length)
    return category.items.map((item, index) =>
      <a
        className={['item__container', itemContainerClass].join(' ')}
        key={index}
        href={addUtmSourceItem(item.url, category.analytics, item.analytics)}
        data-analytics-event-category="Navigation mobile"
        data-analytics-event-action="nav bar click"
        data-analytics-event-label={category.analytics + '=>' + item.analytics}
        data-analytics-event-value={'1=>' + categoryIndex + '=>' + index}
      >
        <Image {...imageProps(item.icon, 'item__image')} />
        <div className="item__description">
          {item.description}
        </div>
      </a>
    )
  }

  getExpendableCategories() {
    return this.props.categories.filter(category => {
      return category.items.items !== null
    })
  }

  getNoneExpendableCategories() {
    return this.props.categories.filter(category => {
      return category.items.items === null
    })
  }

  renderNoneExpandableCategories = () => {
    if (this.getNoneExpendableCategories().length === 0) return
    return this.getNoneExpendableCategories().map((category, index) => {
      return (
        <a
          href={addUtmSourceCategory(category.url, category.analytics)}
          target="_self"
          className="category__link-container"
          data-analytics-event-category="Navigation mobile"
          data-analytics-event-action="nav bar click"
          data-analytics-event-label={category.analytics}
          data-analytics-event-value={'1=>' + index}
        >
          <Image {...imageProps(category.icon, 'category__image')} />
          <div className="category__description">
            {category.description}
          </div>
        </a>
      )
    })
  }

  renderExpandableCategories = () => {
    if (this.getExpendableCategories().length === 0) return
    return this.getExpendableCategories().map((category, index) => {
      const itemsContainerClass = getItemsContainerClass(category.items.length)
      return (
        <ExpandableContainer key={index}>
          <ExpandableContainer.Header className="category__arrow-icon">
            <Image {...imageProps(category.icon, 'category__image')} />
            <div className="category__description">
              {category.description}
            </div>
          </ExpandableContainer.Header>
          <ExpandableContainer.Content>
            <div className="items-container__wraaper">
              <div className={['items-container', itemsContainerClass].join(' ')}>
                {this.renderItems(category, index)}
              </div>
            </div>
          </ExpandableContainer.Content>
        </ExpandableContainer>
      )
    })
  }

  shouldRenderExpandable() {
    return this.getExpendableCategories().length > 0 ? true : false
  }

  shouldRenderNoneExpandable() {
    return this.getNoneExpendableCategories().length > 0 ? true : false
  }

  renderExpandableWrraper() {
    return (
      <AccordionContainer>
        {this.renderExpandableCategories()}
      </AccordionContainer>
    )
  }

  render() {
    return (
      <div
        className={`categories__wrapper ${this.props.isOpen
          ? 'categories__wrapper__container-opened'
          : 'categories__wrapper__container-closed'}`}
      >
        <div className="categories__container">
          {this.shouldRenderExpandable() ? this.renderExpandableWrraper() : ''}
          {this.shouldRenderNoneExpandable() ? this.renderNoneExpandableCategories() : ''}
        </div>
        <div className="categories__chevron-container" onClick={() => this.props.closeMenu()}>
          <Image {...imageProps(getIcon('mainNavigationChevron'), 'mainNavigationChevron-icon')} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/navigation/Categories.container.js